/* Ashdeco PDP V3: Subtotal ben phai o Quantity (chi khi nap qua ahm-v3-pdp-skin).
   Subtotal = gia dang chon x so luong, HIEN NGUYEN GIA. CHI khi khach bam Apply o khoi "10% OFF" (nut [data-td-apply] co aria-pressed="true") thi hien gia sau giam
   (gia goc gach ngang + gia moi + "10% off at checkout"). Khong tu giam theo gio hang hay nguong: bam theo dung trang thai Apply cua khoi do.
   Giam gia that van do automatic discount tai checkout; day chi la hien thi.
   Khong sua section san pham: doc gia tu .phr-price-main, so luong tu [data-phr-qty-input], phan tram tu [data-phr-tdisc]. */
(function () {
  'use strict';
  var d = document, S = 'section.phr-section';
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var fmt; try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }); } catch (e) { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
  function money(c) { return fmt.format(c / 100); }
  function centsOf(el) { var t = (el.textContent || '').replace(/[^0-9.]/g, ''); var n = parseFloat(t); return isFinite(n) ? Math.round(n * 100) : 0; }
  function build(row) {
    if (row.querySelector('.v3-subtotal')) return;
    var box = d.createElement('div'); box.className = 'v3-subtotal'; box.setAttribute('aria-live', 'polite'); box.setAttribute('data-v3-subtotal', '');
    var l = d.createElement('span'); l.className = 'v3-st-label'; l.textContent = 'Subtotal'; var a = d.createElement('span'); a.className = 'v3-st-amt'; var n = d.createElement('span'); n.className = 'v3-st-note'; n.hidden = true;
    box.appendChild(l); box.appendChild(a); box.appendChild(n); row.appendChild(box);
  }
  function applied() {
    var td = d.querySelector(S + ' [data-phr-tdisc]'); if (!td || td.hidden) return 0;
    var b = td.querySelector('[data-td-apply]'); if (!b || b.getAttribute('aria-pressed') !== 'true') return 0;
    return parseInt(td.getAttribute('data-td-pct'), 10) || 0;
  }
  function render() {
    var priceEl = d.querySelector(S + ' .phr-price-main'); if (!priceEl) return; var unit = centsOf(priceEl); if (!unit) return; var pct = applied();
    qsa(S + ' .phr-cta-qty-row').forEach(function (row) {
      build(row); var inp = row.querySelector('[data-phr-qty-input]') || d.querySelector(S + ' [data-phr-qty-input]'); var q = Math.max(1, parseInt(inp && inp.value, 10) || 1);
      var line = unit * q, amt = row.querySelector('.v3-st-amt'), note = row.querySelector('.v3-st-note');
      if (pct) { var fin = Math.round(line * (100 - pct) / 100); amt.textContent = ''; var s = d.createElement('s'); s.textContent = money(line); var b = d.createElement('b'); b.textContent = money(fin); amt.appendChild(s); amt.appendChild(b); note.textContent = pct + '% off at checkout'; note.hidden = false; }
      else { amt.textContent = money(line); note.hidden = true; }
    });
  }
  function init() {
    if (!d.querySelector(S + ' .phr-cta-qty-row')) return;
    render();
    qsa(S + ' [data-phr-qty-btn]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(render, 0); }); });
    qsa(S + ' [data-phr-qty-input]').forEach(function (i) { ['input', 'change'].forEach(function (ev) { i.addEventListener(ev, function () { setTimeout(render, 0); }); }); });
    qsa(S + ' .phr-price-main').forEach(function (p) { new MutationObserver(function () { render(); }).observe(p, { childList: true, characterData: true, subtree: true }); });
    qsa(S + ' [data-td-apply]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(render, 0); }); new MutationObserver(function () { render(); }).observe(b, { attributes: true, attributeFilter: ['aria-pressed'] }); });
    qsa(S + ' [data-phr-tdisc]').forEach(function (t) { new MutationObserver(function () { render(); }).observe(t, { attributes: true, attributeFilter: ['hidden'] }); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); }); else setTimeout(init, 300);
})();

/* Khoi chon mau go (Wood tone, 4 o anh, thuoc tinh don hang "Wood tone"): dong bo nhan va o dang chon giua hai ban render (desktop + mobile stack).
   Hai ban radio cung name trong mot form nen trinh duyet chi giu mot o checked (gia tri gui di khop voi o vua bam); trang thai hien thi do lop is-active. */
(function () {
  'use strict';
  var d = document;
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function init() {
    var blocks = qsa('[data-phr-tone]'); if (!blocks.length) return;
    function show(idx, title) {
      blocks.forEach(function (bl) {
        qsa('[data-tone-item]', bl).forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-tone-index') === String(idx)); });
        qsa('[data-tone-selected]', bl).forEach(function (s) { s.textContent = title; });
      });
    }
    blocks.forEach(function (bl) {
      qsa('[data-tone-radio]', bl).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!this.checked) return; var it = this.closest('[data-tone-item]');
          show(this.getAttribute('data-tone-index'), it ? it.getAttribute('data-tone-title') : this.value);
        });
      });
    });
    // trang thai dau: neu co o checked san (chon san trong editor) thi dong bo nhan
    var r0 = d.querySelector('[data-phr-tone] [data-tone-radio]:checked'); if (r0) { var i0 = r0.closest('[data-tone-item]'); show(r0.getAttribute('data-tone-index'), i0 ? i0.getAttribute('data-tone-title') : r0.value); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
